import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import WelcomeModalContent from './content';
import { SimpleModal } from '@livable/saas-react-components';
export default function WelcomeModal() {
  const urlParams = new URLSearchParams(window.location.search);
  const isModalOpen = urlParams.get('isappfolio');
  const _useState = useState(!!isModalOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(SimpleModal, {
    isOpen: isOpen,
    noHeader: true,
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(WelcomeModalContent, {
    handleClose: () => setIsOpen(false)
  }));
}